import messages from "./messages.yaml";
export default {
  locale: navigator.language.split("-")[0] || "pt",
  fallbackLocale: "pt",
  messages
};
